// ModalCriacaoUsuario.js (Corrigido: Layout Vertical e Form Completo)

import React, { useState } from 'react';

function ModalCriacaoUsuario({ isOpen, onClose, onSave }) {
    const [nomeCompleto, setNomeCompleto] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [cpf, setCpf] = useState('');
    const [conselho, setConselho] = useState('');
    const [numConselho, setNumConselho] = useState('');
    const [cargo, setCargo] = useState('');
    const [funcao, setFuncao] = useState('');

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        // Validação mínima
        if (!nomeCompleto || !cpf || !cargo || !funcao) {
            alert('Por favor, preencha no mínimo: Nome Completo, CPF, Cargo e Função.');
            return;
        }

        const dadosUsuario = {
            nomeCompleto,
            dataNascimento,
            cpf,
            conselho,
            numConselho,
            cargo,
            funcao
        };

        onSave(dadosUsuario);
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content modal-lg" onClick={(e) => e.stopPropagation()}>
                <h2>Dados do Novo Usuário</h2>
                <form onSubmit={handleSubmit}>

                    <div className="form-group">
                        <label>Nome Completo</label>
                        <input type="text" value={nomeCompleto} onChange={(e) => setNomeCompleto(e.target.value)} required />
                    </div>

                    <div className="form-group">
                        <label>Data de Nascimento</label>
                        <input type="date" value={dataNascimento} onChange={(e) => setDataNascimento(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label>CPF</label>
                        <input type="text" value={cpf} onChange={(e) => setCpf(e.target.value)} required />
                    </div>

                    <div className="form-group">
                        <label>Conselho (Ex: CRM, COREN)</label>
                        <input type="text" value={conselho} onChange={(e) => setConselho(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label>Nº do Conselho</label>
                        <input type="text" value={numConselho} onChange={(e) => setNumConselho(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label>Cargo</label>
                        <input type="text" value={cargo} onChange={(e) => setCargo(e.target.value)} required />
                    </div>

                    <div className="form-group">
                        <label>Função</label>
                        <input type="text" value={funcao} onChange={(e) => setFuncao(e.target.value)} required />
                    </div>

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="btn-cancel">Cancelar</button>
                        <button type="submit" className="btn-save">Salvar Dados</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ModalCriacaoUsuario;